import $ from 'jquery'
import {lockBody, unlockBody} from "../_utils";

let postSummaryOpen = false;

$(document).on('click', '.js-open-summary', function (e) {
    e.preventDefault();

    $('.js-post-summary').slideDown(500);

    postSummaryOpen = true;
    lockBody();
});

$(document).on('click', '.js-close-summary', function (e) {
    e.preventDefault();

    $('.js-post-summary').slideUp(500);

    postSummaryOpen = false;
    unlockBody();
});

const media = window.matchMedia('(min-width: 992px)');

media.addEventListener('change', function (e) {
    if (e.matches) {
        postSummaryOpen = false;

        unlockBody();

        $('.js-post-summary').removeAttr('style');
    }
});